import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';

export const Container = styled('div')`
  border-right: 1px solid ${colours.neutral[300]};
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  padding: 15px;
  width: 260px;

  /* Hide scrollbar but keep scroll functionality */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  /* Webkit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${breakpoints.tablet}) {
    border-right: none;
    overflow-y: visible;
    padding: 0;
    width: 100%;
  }
`;

export const PageTitle = styled('div')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  min-height: 60px;
  width: 100%;
`;

export const Row = styled('div')`
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  display: flex;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    cursor: pointer;
    padding: 0;
  }
`;

export const Item = styled('div')<{
  isActive?: boolean;
  isSelected?: boolean;
}>`
  align-items: center;
  background-color: ${({ isActive, isSelected }) => {
    if (isActive) return colours.neutral[200];
    if (isSelected) return colours.neutral[100];
    return 'transparent';
  }};
  border-radius: 100px;
  box-sizing: border-box;
  display: flex;
  gap: 30px;
  height: 60px;
  max-height: 60px;
  justify-content: space-between;
  padding: 10px 17px;
  width: 100%;
  position: relative;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    background-color: white;
  }

  ${({ isActive, isSelected }) =>
    !isActive &&
    !isSelected &&
    `
    @media (min-width: ${breakpoints.tablet}) {
      &:hover {
        background-color: ${colours.neutral[300]};
      }
  `}

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
    pointer-events: none;
  }

  &:active::before {
    width: 300px;
    height: 300px;
    transition: width 0s, height 0s;
  }
`;

export const TextContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 3px;
  transition: transform 0.2s ease;
`;

export const Heading = styled(Text.P2Semibold)`
  display: flex;
  flex-direction: column;
  gap: 0;
  transition: color 0.2s ease;
`;

export const Subheading = styled(Text.Label)``;

export const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    width: 22px;
    height: 22px;
    stroke-width: 2;
  }
`;
